export const auctionTypes = {
  CLOSE: 'close',
  OPEN: 'open',
}
